<template>
  <li :class="{ 'in-view': inView }">
    <a :href="`#${heading.id}`" class="inline-block w-full truncate" @click="scrollToId">{{ heading.text }}</a>
    <ul v-if="heading.children.length">
      <template v-for="child in heading.children" :key="child.text">
        <atoms-sb-toc-item v-if="heading.children.length > 0" :heading="child" :uid="uid" class="pl-2" />
      </template>
    </ul>
  </li>
</template>

<script setup lang="ts">
import type { nestedHeading } from "../sb-toc.vue"

const props = defineProps<{ heading: nestedHeading; uid: string; }>()
const inView = ref(false)

function scrollToId() {
  window.requestAnimationFrame(() =>
    window.scrollTo(0, (document.querySelector(`#${props.heading.id}`) as HTMLElement).getBoundingClientRect().top + window.scrollY - 120),
  )
}

function checkInView() {
  const el = document.querySelector<HTMLElement>(`#${props.heading.id}`)
  inView.value = !!(el && el.getBoundingClientRect().top + window.scrollY - 160 < window.scrollY)
}

onMounted(() => {
  window.addEventListener("scroll", checkInView, { passive: true })
  window.addEventListener("resize", checkInView, { passive: true })
})

onBeforeUnmount(() => {
  window.removeEventListener("scroll", checkInView)
  window.removeEventListener("resize", checkInView)
})
</script>

<style scoped>
a {
  @apply -m-1 inline-block w-full;
  @apply -mx-1 rounded border-2 border-transparent p-0.5 text-base outline outline-2 outline-transparent transition-colors duration-[50ms];
  @apply hover:outline-text focus:outline-text active:text-text-accent active:outline-text-accent;
}

li > ul a {
  outline-color: transparent !important;
}

.in-view:not(:has(~ .in-view)) > a {
  @apply outline-text;
}
</style>
